var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"main"},[_c('img',{attrs:{"loading":"lazy","src":require("@/assets/images/common/logo-loading.svg")}}),_c('div',{staticClass:"content"},[_c('span')])])])
}]

export { render, staticRenderFns }